import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

interface Option {
  value: string;
  label: string;
  color?: string;
}

interface OptionSelectorProps {
  label: string;
  options: Option[];
  value: string | null;
  onChange: (value: string) => void;
}

export default function OptionSelector({
  label,
  options,
  value,
  onChange,
}: OptionSelectorProps) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="overline"
        sx={{
          fontSize: "0.65rem",
          color: "text.secondary",
          letterSpacing: 1.5,
          mb: 0.75,
          display: "block",
        }}
      >
        {label}
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, v) => v && onChange(v)}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 0.5,
          "& .MuiToggleButton-root": {
            flex: "1 1 auto",
            fontSize: "0.75rem",
            py: 0.75,
            px: 1.5,
            border: "1px solid rgba(255,255,255,0.08)",
            color: "text.secondary",
            textTransform: "none",
            borderRadius: "8px !important",
            "&.Mui-selected": {
              backgroundColor: "rgba(79,195,247,0.15)",
              color: "primary.main",
              borderColor: "rgba(79,195,247,0.3)",
              "&:hover": {
                backgroundColor: "rgba(79,195,247,0.2)",
              },
            },
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.05)",
            },
          },
        }}
      >
        {options.map((opt) => (
          <ToggleButton key={opt.value} value={opt.value}>
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
